import React, { useEffect, useState } from "react";
import { languageMessages } from "traductor/PageConfirmation";
import '../styles/ScreenConfirmationLink.css'
import { getTodayDateCustom, linkUrlWithOption } from "services/link/types";
import { useLocation } from "react-router-dom";
import { IN_PROGRESS, PAID, PaymentOutcome, REJECTED } from "services/payment/outcome";

interface PageConfirmationProps {
    language: string;
    firstname: string;
    amount: string;
    policy: string;
    card: string;
    date: string;
    type: string;
    outcome: PaymentOutcome;
    awaitsBankTransfer?: boolean;
    onRetry?: () => void;
}

function PageConfirmation({ language, firstname, amount, policy, card, date, type, outcome, awaitsBankTransfer, onRetry }: PageConfirmationProps) {

        const location = useLocation();

        const formattedDate = getTodayDateCustom();

        const { title1, title2, title3, titleProcessing, titleRejected, subtitle1, subtitle2, subtitle3, subtitle4, subtitleProcessing, subtitleRejected, data1, data2, data3, data4, data5, data6, button1, button2, buttonRetry, close } = languageMessages[language];

        const [isVantage, setIsVantage] = useState(false);

        useEffect(() => {
            const queryParams = new URLSearchParams(location.search);
            const originVantage = queryParams.get('origin') ?? '';

            setIsVantage(originVantage === 'app-mobile');
            // eslint-disable-next-line
        }, []);

        const onHandleRedirectHome = () => {
            // @ts-ignore
            window.ReactNativeWebView.postMessage("payment-back")
        }

        const isPaid = outcome === PAID;
        const isRejected = outcome === REJECTED;
        const showsTransferNotice = outcome === IN_PROGRESS && Boolean(awaitsBankTransfer);

        const resolveIcon = () => {
            if (isRejected) return 'url("icon-payment-rejected.svg")';
            if (!isPaid) return 'url("icon_information.svg")';
            return type === 'payment' ? 'url("check-payment.png")' : 'url("icon-card.gif")';
        };

        const headline = showsTransferNotice ? title3 : isRejected ? titleRejected : titleProcessing;
        const supportingText = showsTransferNotice ? subtitle4 : isRejected ? subtitleRejected : subtitleProcessing;
        const hidesSupportingText = showsTransferNotice && type !== 'payment';

        return (
            <div className='app-confirmation'>
                <div className='app-body-confirmation'>
                    <div className='img' style={{ backgroundImage: resolveIcon(), backgroundSize: '120px' }}></div>
                    {isPaid &&
                        <div className='text'>
                            <div className='title'>{firstname}, {type === 'payment' ? title1 : title2}</div>
                            <div className='subtitle' style={type === 'payment' ? {display: 'block'} : {display: 'none'}}> {subtitle1} <b>{amount}</b> {subtitle2}</div>
                            <div className='subtitle' style={type === 'payment' ? {display: 'none'} : {display: 'block'}}> {subtitle3}</div>
                        </div>
                    }
                    {!isPaid && <div className='text'>
                        <div className={isRejected ? 'title title-rejected' : 'title'}>{headline}</div>
                        <div className='subtitle' style={hidesSupportingText ? {display: 'none'} : {display: 'block'}}> {supportingText}</div>
                    </div>}
                    {isPaid && <div className='paymentInfoC'>
                        <div className="container">
                            <div className="content">
                                <div className='field'>{data1}</div>
                                <div className='data'>{policy}</div>
                            </div>
                        </div>
                        <div className="container" style={type === 'payment' ? {display: 'none'} : {display: 'block'}}>
                            <div className="content">
                                <div className='field'>{data4}</div>
                                <div className='data'>**** **** **** {card}</div>
                            </div>
                        </div>
                        <div className="container" style={type === 'payment' ? {display: 'none'} : {display: 'block'}}>
                            <div className="content">
                                <div className='field'>{data5}</div>
                                <div className='data'>{firstname}</div>
                            </div>
                        </div>
                        <div className="container" style={type === 'payment' ? {display: 'none'} : {display: 'block'}}>
                            <div className="content">
                                <div className='field'>{data6}</div>
                                <div className='data'>{date}</div>
                            </div>
                        </div>
                        <div className="container" style={type === 'payment' ? {display: 'block'} : {display: 'none'}}>
                            <div className="content">
                                <div className='field'>{data2}</div>
                                <div className='data'>{formattedDate}</div>
                            </div>
                        </div>
                        <div className="container" style={type === 'payment' ? {display: 'block'} : {display: 'none'}}>
                            <div className="content">
                                <div className='field'>{data3}</div>
                                <div className='data' style={{color: '#00D090'}}>{amount}</div>
                            </div>
                        </div>
                    </div>}
                    {!isPaid && !isRejected &&
                        <div className='paymentPendingScreen'></div>
                    }
                    {isRejected && onRetry && <div className="container-button">
                        <button className='button-c' onClick={onRetry}>{buttonRetry}</button>
                    </div>}
                    {isPaid && !isVantage && <div className="container-button">
                        <button className='button-c' onClick={() => { localStorage.setItem('selectedLinkOption', 'payment'); window.location.assign(linkUrlWithOption(window.location.pathname, window.location.search, 'payment')) }}>{type === 'payment' ? button1 : button2}</button>
                    </div>}
                    {
                    isPaid && isVantage && <div className="container-button">
                        <button className='button-c' onClick={() => { onHandleRedirectHome() }}>{close}</button>
                    </div>
                    }
                </div>
            </div>
      );
}

export default PageConfirmation;
